import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { PixiPlugin } from "gsap/PixiPlugin.js";
import { Draggable } from "gsap/Draggable";
import * as PIXI from 'pixi.js-legacy';
import fit from 'math-fit';

gsap.registerPlugin(PixiPlugin);
gsap.registerPlugin(Draggable);
PixiPlugin.registerPIXI(PIXI);

function heroSliderFunction() {
	if($(".wp-block-keztablocks-webgl-slider").length > 0) {
		$(".wp-block-keztablocks-webgl-slider").each(function() {
			const self = $(this),
				slides = self.find(".wp-block-keztablocks-webgl-slide"),
				images = self.find(".wp-block-keztablocks-webgl-slide img"),
				inners = self.find(".wp-block-keztablocks-webgl-slide__inner"),
        		dots = self.find(".wp-block-keztablocks-webgl-slider__bullets"),
		        activeDotColor = dots.attr("data-active"),
		        activeDotBorColor = dots.attr("data-bor-active"),
		        dotColor = dots.attr("data-dot");
		    let dmapImage = self.find(".wp-block-keztablocks-webgl-slider__dmap"),
				dmapSrc = dmapImage.css('background-image').replace(/^url\(['"]?/,'').replace(/['"]?\)$/,'');
			let dRippleImage = self.find(".wp-block-keztablocks-webgl-slider__dripple"),
				dRipplepSrc = dRippleImage.css('background-image').replace(/^url\(['"]?/,'').replace(/['"]?\)$/,'');
				// nextNav = self.find(".wp-block-keztablocks-webgl-slider__nav-next"),
				// prevNav = self.find(".wp-block-keztablocks-webgl-slider__nav-prev");

			let imageSrc = [];
			let sprite = [];
			let i, nextLoop;

			let tl = gsap.timeline();

			let _w = self[0].offsetWidth,
			    _h = self[0].offsetHeight;

			$(window).on('resize', resize);

			const app = new PIXI.Application({
			    width: _w,
			    height: _h,
				backgroundColor: 0x111111,
				// resizeTo: window
			});

			self.append(app.view);

			const container = new PIXI.Container();
			app.stage.addChild(container);

			app.renderer.plugins.interaction.moveWhenInside = true;

			const loader = PIXI.Loader.shared;
			loader.add('cloud', dmapSrc)
			.add('ripple', dRipplepSrc);

			function pushSrc() {
				for ( i = 0; i < images.length; i++ ) {
					let img = images;
					imageSrc.push( img.eq(i).attr('src') );
					loader.add(img.eq(i).attr('src'));
				}
			}
			pushSrc()

			let posX, vx, map, displacementSpriteCloud, displacementFilterCloud, displacementSpriteRipple, displacementFilterRipple;

			loader.load(function() {
				loaderSetup();
				hideSprite()
				heroActiveReveal()
			});

			function resize() {
				_w = self[0].offsetWidth,
			    _h = self[0].offsetHeight;

				app.renderer.resize(_w, _h);
				loaderSetup()
				hideSprite()
			}

			function loaderSetup() {
				let parent = {
					width: _w,
					height: _h
				};

				//displacementMap Cloud
				displacementSpriteCloud = new PIXI.Sprite(loader.resources.cloud.texture);

				let cloudTarget = {
					width: displacementSpriteCloud.texture.width, // or width: 200
					height: displacementSpriteCloud.texture.height // or height: 100
				};

				let coverCloud = fit(cloudTarget, parent);

				displacementSpriteCloud.position.set(coverCloud.left,coverCloud.top);
				displacementSpriteCloud.scale.set(coverCloud.scale,coverCloud.scale);
				// displacementSpriteCloud.anchor.set(0.5);
				// displacementSpriteCloud.x = app.renderer.width / 2;
				// displacementSpriteCloud.y = app.renderer.height / 2;

				displacementFilterCloud = new PIXI.filters.DisplacementFilter(displacementSpriteCloud);
				displacementFilterCloud.scale.set('0');
				app.stage.addChild(displacementSpriteCloud);
				app.stage.filters = [displacementFilterCloud];

				//displacementMap Ripple
				posX = app.renderer.width / 2;
			    displacementSpriteRipple = new PIXI.Sprite(loader.resources.ripple.texture);
			    displacementFilterRipple = new PIXI.filters.DisplacementFilter(displacementSpriteRipple);
			    displacementSpriteRipple.anchor.set(0.5);
			    displacementSpriteRipple.x = app.renderer.width / 2;
			    displacementSpriteRipple.y = app.renderer.height / 2;
			    vx = displacementSpriteRipple.x;

			    app.stage.addChild(displacementSpriteRipple);
			    container.filters = [displacementFilterRipple];
			    container.interactive = true;
			    displacementFilterRipple.scale.x = 0;
			    displacementFilterRipple.scale.y = 0;

				for ( i = 0; i < images.length; i++ ) {

					sprite[i] = new PIXI.Sprite(loader.resources[imageSrc[i]].texture);

					let target = {
						width: sprite[i].texture.width, // or width: 200
						height: sprite[i].texture.height // or height: 100
					};

					let cover = fit(target, parent);

					sprite[i].position.set(cover.left,cover.top);
					sprite[i].scale.set(cover.scale,cover.scale);

					sprite[i].alpha = 0;

					container.addChild( sprite[i] );

					
				}
				container.on('mousemove', onPointerMove).on('touchmove', onPointerMove);
    			loop();

			}

			function hideSprite() {
				var active = slides.index($(".wp-block-keztablocks-webgl-slide.active"));
				gsap.set(sprite[active], {pixi:{alpha:1}})
			}
			
			function onPointerMove(eventData) {
				posX = eventData.data.global.x;
			}

			// create a function that continually updates the screen. A velocity for the x-axis is worked out using the position of the mouse and the ripple.

			function loop() {
			    requestAnimationFrame(loop);
			    vx += (posX - displacementSpriteRipple.x) * 0.045;
			    displacementSpriteRipple.x = vx;
			    let disp = Math.floor(posX - displacementSpriteRipple.x);
			    if (disp < 0) disp = -disp;
			    let fs = map(disp, 0, 500, 0, 320);
			    disp = map(disp, 0, 900, 0.1, 0.6);
			    displacementSpriteRipple.scale.x = disp;
			    displacementFilterRipple.scale.x = fs;
			}

			// Finally, the map function is declared that maps value ranges to new values.

			map = function(n, start1, stop1, start2, stop2) {
			    let newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
			    return newval;
			};

			function dotClick() {
		        if(!tl.isActive()) {
		          var slideFrom = self.find(".wp-block-keztablocks-webgl-slide.active"),
		            	innerFrom = slideFrom.find(".wp-block-keztablocks-webgl-slide__inner"),
		              sectionToIndex = $(this).index(),
		            	imgFrom = sprite[slideFrom.index()],
		              slideTo = slides.eq(sectionToIndex),
		              innerTo = inners.eq(sectionToIndex),
		              imgTo = sprite[sectionToIndex];

		          if(slideFrom.index() !== slideTo.index()) {
		            moveToSlide(slideFrom, slideTo, imgFrom, imgTo, innerFrom, innerTo);
		          }

		          if (self.hasClass("has-autoplay")) {
		            // Stop the last one
		              nextLoop.kill();
		              // Start it again
		              looper();
		          }
		        }
		    }

			function nextClick() {
		      if(!tl.isActive()) {
		        var slideFrom = self.find(".wp-block-keztablocks-webgl-slide.active"),
		              innerFrom = slideFrom.find(".wp-block-keztablocks-webgl-slide__inner"),
		            sectionIndex = slides.index(slideFrom),
		            imgFrom = sprite[sectionIndex];

		        if(sectionIndex !== slides.length - 1) {
		          var slideTo = slides.eq(sectionIndex + 1),
		          		innerTo = inners.eq(sectionIndex + 1),
		              imgTo = sprite[sectionIndex + 1];
		          moveToSlide(slideFrom, slideTo, imgFrom, imgTo, innerFrom, innerTo);
		        } else {
		          slideTo = slides.eq(0);
		          innerTo = inners.eq(0);
		          imgTo = sprite[0];
		          moveToSlide(slideFrom, slideTo, imgFrom, imgTo, innerFrom, innerTo);
		        }

		        if (self.hasClass("has-autoplay")) {
		            // Stop the last one
		              nextLoop.kill();
		              // Start it again
		              looper();
		          }
		      }
		    }

		    function prevClick() {
		      if(!tl.isActive()) {
		        var slideFrom = self.find(".wp-block-keztablocks-webgl-slide.active"),
		              innerFrom = slideFrom.find(".wp-block-keztablocks-webgl-slide__inner"),
		            sectionIndex = slides.index(slideFrom),
		            imgFrom = sprite[sectionIndex];

		        if(sectionIndex !== 0) {
		          var slideTo = slides.eq(sectionIndex - 1),
		          		innerTo = inners.eq(sectionIndex - 1),
		              imgTo = sprite[sectionIndex - 1];
		          moveToSlide(slideFrom, slideTo, imgFrom, imgTo, innerFrom, innerTo);
		        } else {
		          slideTo = slides.eq(slides.length - 1);
		          innerTo = inners.eq(slides.length - 1);
		          imgTo = sprite[slides.length - 1];
		          moveToSlide(slideFrom, slideTo, imgFrom, imgTo, innerFrom, innerTo);
		        }

		        if (self.hasClass("has-autoplay")) {
		            // Stop the last one
		              nextLoop.kill();
		              // Start it again
		              looper();
		          }
		      }
		    }

		    function moveToSlide(slideFrom, slideTo, imgFrom, imgTo, innerFrom, innerTo) {
		    	tl = gsap.timeline({onStart: setActiveSlide, onStartParams: [slideTo]})
				.to(innerFrom, {duration: 0.4, autoAlpha:0, ease:"power1.in",force3D:false})
				.to(displacementFilterCloud, {pixi:{scaleX:2000,scaleY:2000}, ease:"power2.in", duration:1}, "<")
				.to(imgFrom, {pixi:{alpha:0}, ease:"power2.in", duration:1}, "<")
				.set(slideTo, {autoAlpha:1, className: "wp-block-keztablocks-webgl-slide active"}, "<")
				.set(slideFrom, {className: "wp-block-keztablocks-webgl-slide"}, "<")
				.fromTo(imgTo, {pixi:{alpha:0}}, {pixi:{ alpha:1}, ease:"power1.in", duration:1},"<0.3")
				.to(displacementFilterCloud, {pixi:{scaleX:0,scaleY:0}, ease:"power1.out", duration:1}, "<0.4")
	            .fromTo(innerTo, {autoAlpha:0},
	             {duration: 0.5, autoAlpha:1, force3D:false}, "<0.4")
				.set(slideFrom, {autoAlpha:0}, "<");
	    	}

	    	function setActiveSlide(slideTo) {
		        var currentSlideIndex = slides.index(slideTo),
		          activeDot = self.find(".wp-block-keztablocks-webgl-slider__bullet.active"),
		          activeDotInner = activeDot.find(".wp-block-keztablocks-webgl-slider__bullet-inner"),
		          defDot = self.find(".wp-block-keztablocks-webgl-slider__bullet").eq(currentSlideIndex),
		          defDotInner = defDot.find(".wp-block-keztablocks-webgl-slider__bullet-inner");
		        gsap.to(activeDot, {duration:0.6,className: "wp-block-keztablocks-webgl-slider__bullet"});
		        gsap.to(activeDotInner, {duration:0.6,backgroundColor:dotColor});
		        gsap.to(defDot, {duration:0.6,className: "wp-block-keztablocks-webgl-slider__bullet active"});
		        gsap.to(defDotInner, {duration:0.6,backgroundColor:activeDotColor, borderColor:activeDotBorColor});

		    }

			if(self.hasClass("is-draggable")) {
				var proxy = $('<div></div>');
				Draggable.create(proxy, {
					trigger: self,
					type: "x",
					cursor: "grab",
					activeCursor: "grabbing",
					onDrag: function() {
						if(this.deltaX > 10) {
							prevClick();
						}
						if(this.deltaX < -10) {
							nextClick();
						}
					}
				})
			}

			if(self.hasClass("is-scrollable")) {
				self.on('mousewheel DOMMouseScroll', function(e) {
					if(typeof e.originalEvent.detail == 'number' && e.originalEvent.detail !== 0) {
						if(e.originalEvent.detail > 0) {
							nextClick()
						} else if(e.originalEvent.detail < 0){
							prevClick()
						}
					} else if (typeof e.originalEvent.wheelDelta == 'number') {
						if(e.originalEvent.wheelDelta < 0) {
							nextClick()
						} else if(e.originalEvent.wheelDelta > 0) {
							prevClick()
						}
					}
				});
			}

			function looper() {
				var autoplayTimer = self.data("autoplay");
				nextLoop = gsap.delayedCall(autoplayTimer, function() {
					nextClick();
				})
			}

			if (self.hasClass("has-autoplay")) {
				looper();
			}

			function heroActiveReveal() {
				var slide = $(".wp-block-keztablocks-webgl-slide.active"),
				loader = $('.c-loader'),
				inners = slide.find(".wp-block-keztablocks-webgl-slide__inner"),
				navs = slide.siblings(".wp-block-keztablocks-webgl-slider__navigation"),
				tl = gsap.timeline({paused:true});

				tl.fromTo(displacementFilterCloud, {pixi:{scaleX:2000,scaleY:2000}}, {pixi:{scaleX:0,scaleY:0}, duration:1})
				.fromTo(sprite[0], {pixi:{alpha:0}}, {pixi:{alpha:1}, duration:1}, "<")
				.fromTo(inners, {autoAlpha:0}, {duration: 0.4, autoAlpha:1})
				.fromTo(navs,{autoAlpha:0},{duration:0.3,autoAlpha:1},"<");

				tl.play();
			}

	    	function init() {
	    		for( var i = 0; i < slides.length; i++ ) {
					var dot = $('<div></div>').addClass("wp-block-keztablocks-webgl-slider__bullet").appendTo(dots);
					var dotInner = $('<div></div>').addClass("wp-block-keztablocks-webgl-slider__bullet-inner").appendTo(dot);
		        }
		        self.find(".wp-block-keztablocks-webgl-slider__bullet:first-child").addClass("active");
				var dotClicked = self.find(".wp-block-keztablocks-webgl-slider__bullet");
				var dotClickedInner = dotClicked.find(".wp-block-keztablocks-webgl-slider__bullet-inner");
				dotClicked.on('click', dotClick);

		        var activeDot = self.find(".wp-block-keztablocks-webgl-slider__bullet.active"),
		          activeDotInner = activeDot.find(".wp-block-keztablocks-webgl-slider__bullet-inner"),
		          defDot = self.find(".wp-block-keztablocks-webgl-slider__bullet"),
		          defDotInner = defDot.find(".wp-block-keztablocks-webgl-slider__bullet-inner");

		        gsap.set(defDotInner, {backgroundColor:dotColor});
		        gsap.set(activeDotInner, {backgroundColor:activeDotColor, borderColor:activeDotBorColor});

				// nextNav.on('click', nextClick);
				// prevNav.on('click', prevClick);

				var activeSlide = self.find(".wp-block-keztablocks-webgl-slide:first");

				gsap.set(activeSlide, {autoAlpha:1, className: "wp-block-keztablocks-webgl-slide active"});
		    }

		    init()
		})
	}
}

heroSliderFunction();